import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@services/translate/translate.service';

@Component({
    selector: 'service-ticket-dialog',
    templateUrl: './service-ticket-dialog.component.html',
    styleUrls: ['./service-ticket-dialog.component.scss'],
    standalone: false
})

export class ServiceTicketDialogComponent {
  title;
  description;
  dataProtection;

  constructor(public dialogRef: MatDialogRef<ServiceTicketDialogComponent>, public ts: TranslateService) {
    this.ts.get('general');
  }

  save() {
    if (this.title && this.description) {
      this.dialogRef.close({title: this.title, description: this.description});
    }
  }
}
